if (!customElements.get('product-personalization')) {
  customElements.define(
    'product-personalization',
    class ProductPersonalization extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-personalization-input]');
        this.counter = this.querySelector('[data-personalization-counter]');
        if (!this.input) return;

        this.maxLength = parseInt(this.dataset.maxLength, 10) || this.input.maxLength || 12;

        // The field ships disabled so a no-JS submit cannot send a personalization
        // that the JS-only add-to-cart flow would never charge for.
        this.input.disabled = false;

        this.input.addEventListener('input', this.onInput.bind(this));
        this.updateCounter();
      }

      onInput() {
        if (this.input.value.length > this.maxLength) {
          this.input.value = this.input.value.slice(0, this.maxLength);
        }
        this.updateCounter();
      }

      updateCounter() {
        if (!this.counter) return;
        this.counter.textContent = `${this.input.value.length}/${this.maxLength}`;
      }

      get value() {
        return this.input ? this.input.value.trim() : '';
      }
    }
  );
}
